const newContainer = () => import("@/layouts/Default.vue");
// const routerParrent = () => import("@/layouts/routerParrent.vue");
// const taskUserPage = () => import("../views/task_user/taskUserPage.vue");
// const showUserTask = () => import("../views/task_user/showUserTask.vue");
// const searchTask = () => import("../views/task/searchTask.vue");
// const editTask = () => import("../views/task/editTask.vue");
// const personContentSearch = () =>
//   import("../views/personContent/personContentSearch.vue");
// const editPersonContent = () =>
//   import("../views/personContent/editPersonContent.vue");
// import paymentPage from "../views/payment/paymentPage.vue";
// import paymentInformationPage from "../views/payment/paymentInformationPage.vue";
const introductionActivitiesResourcesForm = () =>
  import("../views/introductionActivitiesResourcesForm.vue");

export const taskRoutes: any[] = [
  {
    path: "/task",
    name: "task_user",
    meta: {
      label: "خانه",
      moduleName: "task",
    },
    redirect: "/task/task_user/search",
    // component: newContainer,
    children: [
      {
        path: "task_user",
        name: "task_user_search",
        meta: {
          label: "فعالیت",
        },
        // component: routerParrent,
        redirect: "/task/task_user/search",
        children: [
          {
            path: "search",
            name: "taskUserPage",
            // component: taskUserPage,
            meta: {
              label: "کاربری",
            },
          },
          {
            path: "show/:id",
            name: "showUserTask",
            // component: showUserTask,
            meta: {
              label: "نمایش فعالیت کاربر",
            },
          },
          {
            path: "payment/:termStateCode",
            name: "payment",
            // component: paymentPage,
            meta: {
              label: "پرداخت",
              requiresAuth: true,
            },
          },
          {
            path: "payment-info/:id?",
            name: "paymentInfo",
            // component: paymentInformationPage,
            meta: {
              label: "اطلاعات پرداخت",
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "task_admin",
        name: "task_admin",
        meta: {
          label: "کارتابل",
        },
        // component: routerParrent,
        redirect: "/task/task_admin/search",
        children: [
          {
            path: "search",
            name: "search_task_admin",

            // component: searchTask,
            meta: {
              label: "همه فعالیت‌ها",
            },
          },
          {
            path: "edit/:code",
            name: "editTaskAdmin",
            // component: editTask,
            meta: {
              label: "ویرایش فعالیت مدیر",
            },
          },
        ],
      },
      {
        path: "person_content",
        name: "person_content",
        meta: {
          label: "محتوا",
        },
        // component: routerParrent,
        redirect: "/task/person_content/search",
        children: [
          {
            path: "search/:code?",
            name: "searchTask",

            // component: personContentSearch,
            meta: {
              label: "نمایش",
            },
          },
          {
            path: "edit/:id",
            name: "edit-person-content",
            // component: editPersonContent,
            meta: {
              label: "ویرایش محتوا",
            },
          },
        ],
      },
      {
        path: "introduction-activities-resources",
        name: "introduction-activities-resources",
        meta: {
          label: "فرم معرفی فعالیت‌ها و منابع شناخت",
          redesigned: true,
        },
        component: newContainer,
        redirect: "/task/introduction-activities-resources/form",
        children: [
          {
            path: "form",
            name: "introduction-activities-resources-form",
            component: introductionActivitiesResourcesForm,
            meta: {
              label: "فرم معرفی فعالیت‌ها و منابع شناخت",
              redesigned: true,
            },
          },
        ],
      },
    ],
  },
];
